"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformJsonNull = void 0;
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const transformJsonNull = (v) => {
    if (!v || v === 'DbNull')
        return echain_prisma_client_1.Prisma.DbNull;
    if (v === 'JsonNull')
        return echain_prisma_client_1.Prisma.JsonNull;
    return v;
};
exports.transformJsonNull = transformJsonNull;
exports.default = exports.transformJsonNull;
//# sourceMappingURL=transformJsonNull.js.map